// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13aAZ","label":"styles_label__2e8oK"};